<template>
  <nav class="side-nav">
    <ul>
      <li v-for="section in sections" :key="section.id">
        <a
          :href="'#' + section.id"
          :class="{ active: activeSection === section.id }"
          @click.prevent="smoothScroll(section.id)"
        >
          {{ section.name }}
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "SideNav",
  props: {
    sections: Array,
    activeSection: String,
  },
  methods: {
    smoothScroll(id) {
      document.getElementById(id).scrollIntoView({
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.side-nav {
  position: fixed;
  top: 50%;
  right: 50px;
  transform: translateY(-50%);
  z-index: 1000;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: right;
}

li {
  margin: 15px 0;
}

a {
  text-decoration: none;
  color: #888;
  font-weight: 500;
  font-size: 0.9rem;
  position: relative;
  padding-right: 25px;
  transition: all 0.3s ease;
}

a::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  width: 15px;
  height: 2px;
  background-color: #ddd;
  transition: all 0.3s ease;
}

a.active,
a:hover {
  color: #0071e3;
}

a.active::after,
a:hover::after {
  width: 30px;
  background-color: #0071e3;
}
</style>
